module.exports = __webpack_public_path__ + "img/XYLEM.481d90b2.png";